import React from "react";
import { useWatch, useFormContext, Controller } from "react-hook-form";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Grid,
  FormControlLabel,
  Switch,
  Paper,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PERMISSION_TEMPLATE } from "./utils/permissions.constants";

/* ═════════ helper ─ módulo + hijos ═════════ */
const ModuleSection = ({ moduleKey, subModules, source }) => {
  const { control, setValue } = useFormContext();
  const modulePath = `${source}.${moduleKey}`;
  const moduleValue = useWatch({ name: modulePath, control });

  const childKeys = subModules ? Object.keys(subModules) : [];
  const onChildren = childKeys.filter((k) => moduleValue?.[k]);
  const allOn = childKeys.length ? onChildren.length === childKeys.length : !!moduleValue;
  const someOn = childKeys.length ? onChildren.length > 0 : !!moduleValue;

  const handleParentToggle = (checked) => {
    if (childKeys.length) {
      childKeys.forEach((sub) => setValue(`${modulePath}.${sub}`, checked, { shouldTouch: true }));
    } else {
      setValue(modulePath, checked, { shouldTouch: true });
    }
  };

  if (!childKeys.length) {
    // CASO SIMPLE: Tablero u otro sin hijos
    return (
      <Paper sx={{ px: 2, py: 1.5 }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography sx={{ fontWeight: 600 }}>{moduleKey}</Typography>
          <FormControlLabel
            label=""
            control={<Switch checked={!!moduleValue} onChange={(e) => handleParentToggle(e.target.checked)} />}
          />
        </Box>
      </Paper>
    );
  }

  // CASO CON HIJOS
  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontWeight: 600, mt: 0.9 }}>{moduleKey}</Typography>
        <Box sx={{ ml: 1 }}>
          <FormControlLabel
            label=""
            control={
              <Switch
                checked={someOn}
                indeterminate={someOn && !allOn}
                onChange={(e) => handleParentToggle(e.target.checked)}
              />
            }
          />
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        {childKeys.map((sub) => (
          <Box key={sub} sx={{ pl: 1 }}>
            <Controller
              name={`${modulePath}.${sub}`}
              control={control}
              render={({ field }) => (
                <FormControlLabel
                  sx={{ pl: 0 }}
                  label={sub}
                  control={
                    <Switch {...field} checked={!!field.value} onChange={(e) => field.onChange(e.target.checked)} />
                  }
                />
              )}
            />
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
};

/* ═════════ Componente raíz ═════════ */
export const PermissionsInput = ({ source = "permissions" }) => (
  <Grid container spacing={2}>
    {Object.entries(PERMISSION_TEMPLATE).map(([moduleKey, value]) => (
      <Grid item xs={12} sm={6} md={4} key={moduleKey}>
        <ModuleSection moduleKey={moduleKey} subModules={typeof value === "object" ? value : null} source={source} />
      </Grid>
    ))}
  </Grid>
);
